import React from "react";
import { LegacyCard, InlineGrid } from "@shopify/polaris";
import CustomAutocomplete from "../CustomAutocomplete";
import { useLibrary } from "../LibraryContext";

const PocketSquareForm = ({ form, setForm, errors }) => {
  const { linings: LiningNumbers } = useLibrary();
  const sectionKey = "pocketSquare";

  const handleChange = (key) => (values) => {
    const value = Array.isArray(values) ? values[0] : values;
    setForm((prev) => ({
      ...prev,
      [sectionKey]: {
        ...prev[sectionKey],
        [key]: value,
      },
    }));
  };

  return (
    <LegacyCard title="Pocket Square" sectioned>
      <InlineGrid columns={{ xs: 1, sm: 1, md: 2, lg: 3 }} gap="300">
        <CustomAutocomplete
          label="Lining Number"
          optionsList={LiningNumbers}
          onChange={handleChange("liningNumber")}
          defaultValue={form[sectionKey]?.liningNumber || ""}
        />
      </InlineGrid>
    </LegacyCard>
  );
};

export default PocketSquareForm;
